module.exports = __webpack_public_path__ + "img/ic_pathbar_undo.79940b9d.svg";